import { deleteApi, getApi, putApi } from "../../common/api";

export const listContacts = (params: string = "") => {
    return getApi('/api/contacts', params);
};

export const updateContact = (id: string, data: any) => {
    return putApi('/api/contacts/' + id, data);
};

export const deleteContact = (id: string) => {
    return deleteApi('/api/contacts/' + id);
};

export const filterContacts = (status: string) => {
    return getApi('/api/contacts/filter', `?status=${encodeURIComponent(status)}`);
};

export default {
    listContacts,
    updateContact,
    deleteContact,
    filterContacts
};
